import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-permissions-icon-edit",
  "use": "icon-permissions-icon-edit-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-permissions-icon-edit\">\n<path d=\"M18.53 4.47L14.53 0.470002C14.24 0.180002 13.76 0.180002 13.47 0.470002L0.47 13.47C0.33 13.61 0.25 13.8 0.25 14V18C0.25 18.41 0.59 18.75 1 18.75H5C5.2 18.75 5.39 18.67 5.53 18.53L18.53 5.53C18.82 5.24 18.82 4.76 18.53 4.47ZM15 6.94L12.06 4L14 2.06L16.94 5L15 6.94ZM4.69 17.25H1.75V14.31L11 5.06L13.94 8L4.69 17.25Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol